import React from 'react';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';
import ProcessField from 'components/core/fields/ProcessField';
import InfoMessages from 'components/core/help/InfoMessages';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import RIEInput from 'components/core/editable/RIEInput';
import RIECheckboxSelect from 'components/core/editable/RIECheckboxSelect';
import ProcessService from 'services/ProcessService';
import _ from 'lodash';


export default class ProcessEmailField extends ProcessField {

    static propTypes = Object.assign({
        hideWarningLevels: PropTypes.bool
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
        hideWarningLevels: false
    }, ProcessField.defaultProps);

    getEmailSelections() {
        const selections = [];
        const process = this.props.process;
        selections.push({ key: 'Errors', label: 'Errors', checked: !!process.email_errors });
        selections.push({ key: 'Warnings', label: 'Warnings', checked: !!process.email_warnings });
        return selections;
    }

    onNotificationsUpdated = (fieldPath, value) => {
        //TODO: move this to process editor??
        const processCopy = _.cloneDeep(this.props.process);
        processCopy.email_errors = value[0].checked;
        processCopy.email_warnings = value[1].checked;
        ProcessService.updateProcess(this.props.process.name, processCopy);
    };

    renderCheckboxComponent() {
        if (this.props.hideWarningLevels) {
            return <div/>;
        } 
        return (
            <div>
                <Flexbox flexDirection="row" alignItems="flex-start" marginLeft="14px">
                    <div className="form-label nowrap">if the process has:</div>
                    <RIECheckboxSelect
                        value={this.getEmailSelections()}
                        change={this.onNotificationsUpdated}
                        fieldPath={['email_errors']}
                        isDisabled={!this.props.hasWritePermissions}
                        processId={this.props.process.name}
                    />
                </Flexbox>
                <Flexbox flexDirection="row" alignItems="center" marginLeft="14px">
                    <div className="footnote">Notifications are only sent
                        when running in <strong>development</strong> mode</div>
                </Flexbox>
            </div>
        );
    }

    render() {
        const process = this.props.process;
        const label = this.props.hideWarningLevels ? 'Contact Email' : 'Email';
        return (
            <Flexbox flexDirection="column" className={this.props.className}>
                <Flexbox flexDirection="row" alignItems="flex-start" marginBottom="1px" flex="1 0 auto">
                    <InfoBoxLabel
                        label={label}
                        message={InfoMessages.contactEmail}
                    />
                    <RIEInput
                        value={process.notification_email ? process.notification_email : ''}
                        change={this.onFieldUpdated}
                        fieldPath={['notification_email']}
                        isDisabled={!this.props.hasWritePermissions}
                        processId={this.props.process.name}
                        processErrors={this.props.processErrors}
                        formDisplay={this.props.forceFormDisplay}
                    />
                </Flexbox>
                {this.renderCheckboxComponent()}
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/ProcessEmailField.js